import React                    from 'react';
import { observer }             from 'mobx-react';
import { List }                 from 'antd';
import { NavLink }              from 'react-router-dom';
import { Button }               from 'antd';
import dayjs                    from 'dayjs';
import { DownloadOutlined }     from '@ant-design/icons';
import { FileOutlined }         from '@ant-design/icons';
import DemandModel              from 'models/DemandModel';
import DemandTypeModel          from 'models/DemandTypeModel';
import { appStore }             from 'stores/AppStore';
import { standDashboardStore }  from 'stores/index';
import CardBox                  from 'components/App/CardBox';
import FormattedMessageWrapper  from 'components/App/FormattedMessageWrapper';
import DemandStatus             from 'containers/Demand/components/DemandStatus';
import DemandPdfModel           from 'models/DemandPdfModel';
import { downloadFileFromBlob } from 'utils/downloadFile';
import Space                    from 'components/App/Space';
import { messageErrorIntl }     from 'utils/messageIntl';

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

const DemandItem = observer(({
  demand,
  downloadDemandPdf,
}: {
  demand: DemandModel;
  downloadDemandPdf: (demand: DemandModel, locale: string) => void;
}) => {
  const {
    collDemandStatus,
    collDemandType,
  } = standDashboardStore;

  const demandType = collDemandType.findBy('id', demand.get('demandType.id')) as DemandTypeModel;

  return (
    <List.Item key={demand.id}>
      <List.Item.Meta
        description={demand.askedDatetimeDate?.format('[Le ]DD/MM/YYYY[ à ]HH[h]mm') ?? ''}
        title={
          <NavLink to={`/demandes/${demand.id}`}>
            <FormattedMessageWrapper
              id="- Demande de dérogation -"
              values={{
                demandId: demand.formattedId,
                demandTypeLabel: demandType ? demandType.label : '',
              }}
            />
          </NavLink>
        }
      />
      <Space direction="horizontal" size={12}>
        <DemandStatus demand={demand} demandStatusCollection={collDemandStatus} />
            <Button
              icon={<DownloadOutlined />}
              onClick={() => downloadDemandPdf(demand, appStore.locale)}
            >
              <FormattedMessageWrapper id="Télécharger" />
            </Button>
      </Space>
    </List.Item>
  );
});

interface StandDashboardDemandListBoxProps {
  setDataLoading: (loading: boolean) => void;
}

@observer
class StandDashboardDemandListBox extends React.Component<StandDashboardDemandListBoxProps> {
  render() {
    const {
      collPagedDemand,
    } = standDashboardStore;

    return (
      <CardBox
        content={
          <List
            dataSource={collPagedDemand.models}
            loading={collPagedDemand.isLoading}
            locale={{
              emptyText: <FormattedMessageWrapper id="Aucune demande." />,
            }}
            pagination={{
              current: collPagedDemand.page,
              defaultCurrent: collPagedDemand.page,
              hideOnSinglePage: true,
              onChange: page => {
                collPagedDemand.setPage(page);
                collPagedDemand.list();
              },
              pageSize: collPagedDemand.itemsPerPage,
              size: 'small',
              total: collPagedDemand.total,
            }}
            renderItem={(item: DemandModel) => (
              <DemandItem
                demand={item}
                downloadDemandPdf={this._downloadDemandPdf}
              />
            )}
            size="large"
          />
        }
        title={
          <>
            <FileOutlined style={styleIcon} /> <FormattedMessageWrapper id="Demandes" />
          </>
        }
      />
    );
  }

  private _downloadDemandPdf = async (demand: DemandModel, locale: string) => {
    const { setDataLoading } = this.props;
    const { show, stand } = standDashboardStore;

    setDataLoading(true);

    const demandPdf = new DemandPdfModel();
    demandPdf.set({ id: demand.id, locale });

    try {
      const response = await demandPdf.fetch() as any;

      const blob = new Blob([response.data], { type: 'application/pdf' });

      const time = dayjs().format('YYYY-MM-DD_HHmm');

      const filename = `${[show.showName, stand.name, demand.formattedId, time].join('_')}.pdf`;

      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }

    setDataLoading(false);
  };
}

export default StandDashboardDemandListBox;
